/* 🤖 this file was generated by svg-to-ts */
export const mgcIconXSkewCuteFi: {
  name: 'x-skew-cute-fi';
  data: string;
} = {
  name: 'x-skew-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5.72 3.347c-.815.132-1.37.395-1.904.902-.792.752-1.106 1.708-1.214 3.691-.054.986-.054 7.134 0 8.12.108 1.983.422 2.939 1.214 3.691 1.016.965 2.261 1.145 4.924.71.848-.138 7.549-1.396 8.32-1.562 1.138-.245 1.785-.499 2.364-.931.916-.681 1.601-1.691 1.83-2.694.15-.656.166-.972.166-3.294-.001-2.529-.027-2.887-.261-3.589-.388-1.16-1.322-2.242-2.375-2.751-.75-.362-1.049-.43-5.904-1.34-3.786-.71-4.447-.825-5.26-.92-.467-.054-1.643-.074-1.9-.033"/></svg>`
};
